import { useEffect, useMemo, useState } from 'react'

import { useStatus } from '@/hooks/use-status'

const DISMISS_KEY_PREFIX = 'rolling-announcement-dismissed:'

export function useRollingAnnouncement() {
  const { status } = useStatus()
  const content = String(status?.marquee_content ?? '')
    .replace(/\s+/g, ' ')
    .trim()
  const enabled = status?.marquee_enabled === true && content.length > 0
  const signature = useMemo(() => `${DISMISS_KEY_PREFIX}${content}`, [content])
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    try {
      setDismissed(window.localStorage.getItem(signature) === 'true')
    } catch {
      setDismissed(false)
    }
  }, [signature])

  const dismiss = () => {
    try {
      window.localStorage.setItem(signature, 'true')
    } catch {
      // The bar still closes for this page when storage is unavailable.
    }
    setDismissed(true)
  }

  return {
    content,
    visible: enabled && !dismissed,
    dismiss,
  }
}
